export enum Station {
  SCAN1 = 'scan1',
  SCAN2_EMBALLEUR = 'scan2_emballeur',
  SCAN2_SPECIALISTE = 'scan2_specialiste',
}
